// The offer is a quantity shortcut; Dawn's quantity input and product form remain authoritative.
if (!customElements.get('coco-purchase-options')) {
  customElements.define('coco-purchase-options', class extends HTMLElement {
    connectedCallback() {
      this.quantity = document.getElementById(this.dataset.quantityId);
      if (!this.quantity) return;
      this.radios = [...this.querySelectorAll('input[type="radio"]')];
      this.formatter = new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        style: 'currency', currency: this.dataset.currency || 'USD'
      });
      this.onChoice = (event) => {
        if (!this.radios.includes(event.target)) return;
        this.quantity.value = event.target.value;
        this.quantity.dispatchEvent(new Event('change', { bubbles: true }));
      };
      this.onQuantity = () => this.sync();
      this.addEventListener('change', this.onChoice);
      this.quantity.addEventListener('change', this.onQuantity);
      this.observer = new MutationObserver(this.onQuantity);
      this.observer.observe(this.quantity, { attributes: true, attributeFilter: ['min', 'max', 'step'] });
      this.sync();
      const requested = new URLSearchParams(window.location.search).get('quantity');
      const requestedOption = this.radios.find((radio) => radio.value === requested && !radio.disabled);
      if (requestedOption) {
        this.quantity.value = requestedOption.value;
        this.quantity.dispatchEvent(new Event('change', { bubbles: true }));
      }
      this.hidden = false;
    }

    sync() {
      const quantity = Number(this.quantity.value);
      const min = Number(this.quantity.min) || 1;
      const max = this.quantity.max === '' ? Infinity : Number(this.quantity.max);
      const step = Number(this.quantity.step) || 1;
      this.radios.forEach((radio) => {
        const value = Number(radio.value);
        radio.disabled = value < min || value > max || (value - min) % step !== 0;
        radio.checked = !radio.disabled && value === quantity;
      });
      const total = this.formatter.format(Number(this.dataset.unitPrice) * quantity / 100);
      this.querySelector('[data-purchase-summary]').textContent =
        `${quantity} ${quantity === 1 ? 'pouch' : 'pouches'} · ${total} total`;
    }

    disconnectedCallback() {
      this.removeEventListener('change', this.onChoice);
      this.quantity?.removeEventListener('change', this.onQuantity);
      this.observer?.disconnect();
    }
  });
}
